import(/* webpackMode: "eager" */ "/home/webnode/app/eduline-web/src/app/not-found.tsx");
